import { useContext } from 'react';
import SessionCheckContext from '../components/SessionCheckContext';

const useAuth = () => (
  useContext(SessionCheckContext).auth
);

export default useAuth;
